<mat-card class="prompt-log-container">
  <div class="card-header">
    <div>
      <h2 class="log-title">Advisor Log</h2>
      <p class="log-subtitle">View recent Advisor responses</p>
    </div>
    <mat-form-field class="collection-select" appearance="outline">
      <mat-label>Collection</mat-label>
      <mat-select [(value)]="selectedCollection" (selectionChange)="onCollectionChange($event)">
        <mat-option *ngFor="let collection of collections" [value]="collection.name">
          {{ collection.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="loading" class="loading-container">
    <mat-spinner></mat-spinner>
  </div>
  <mat-accordion displayMode="flat" class="example-headers-align" multi="true" *ngIf="!loading">
    <mat-expansion-panel hideToggle="true" *ngFor="let log of advisorLogs">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>question_answer</mat-icon>
          <span class="title-text">{{ log.title }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <!-- Log Info -->
      <h2>Prompt Log</h2>
      <mat-card>
        <div *ngIf="log">
          <div *ngIf="log.user"><strong>User:</strong> {{ log.user }}</div>
          <div *ngIf="log.title"><strong>Title:</strong> {{ log.title }}</div>
        </div>
      </mat-card>

      <!-- Log Prompt and Response -->
      <mat-card>
        <h3>Prompt</h3>
        <pre class="response-content">{{ log.prompt }}</pre>
      </mat-card>
      <mat-card>
        <h3>Response</h3>
        <pre class="response-content">{{ log.response }}</pre>
        <button
          mat-icon-button
          color="accent"
          class="bottom-right-spinner"
          matTooltip="Copy to clipboard"
          (click)="copyToClipboard(log.response)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </mat-card>

      <!-- Draft Section -->
      <button mat-raised-button (click)="draftSection(log)" matTooltip="Create a draft section from this log">
        New Draft
      </button>
      <h2 *ngIf="log.drafts">Recent Drafts</h2>
      <mat-expansion-panel class="source-panel" *ngFor="let draft of log.drafts">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>description</mat-icon>
            <span class="title-text">{{ draft.title }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Draft Prompt and Response -->
        <mat-card class="source-card">
          <h3>Prompt</h3>
          <pre class="response-content">{{ draft.prompt }}</pre>
        </mat-card>
        <mat-card class="source-card">
          <h3>Response</h3>
          <pre class="response-content">{{ draft.response }}</pre>
          <button
            mat-icon-button
            color="accent"
            class="bottom-right-spinner"
            matTooltip="Copy to clipboard"
            (click)="copyToClipboard(draft.response)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-card>
      </mat-expansion-panel>

      <!-- Source Documents Section -->
      <h2 *ngIf="log.source_documents">Source Documents</h2>
      <mat-expansion-panel class="source-panel" *ngFor="let document of log.source_documents">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>insert_drive_file</mat-icon>
            <span class="title-text">{{ document.metadata.title }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Document Metadata -->
        <mat-card class="source-card">
          <h3 class="dark-title">Document Metadata</h3>
          <div *ngIf="document.metadata">
            <div *ngFor="let key of getKeys(document.metadata)">
              <strong>{{ key }}:</strong> {{ document.metadata[key] }}
            </div>
          </div>
        </mat-card>

        <!-- Document Content -->
        <mat-card class="source-card">
          <h3 class="dark-title">Summary</h3>
          <pre class="response-content">{{ parseSummary(document.content).summary }}</pre>
        </mat-card>

        <mat-card class="source-card">
          <h3 class="dark-title">Context</h3>
          <pre class="response-content">{{ parseSummary(document.content).context }}</pre>
        </mat-card>
      </mat-expansion-panel>
    </mat-expansion-panel>
  </mat-accordion>
</mat-card>
